import script from "./UserManagementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserManagementView.vue?vue&type=script&setup=true&lang=ts"

import "./UserManagementView.vue?vue&type=style&index=0&id=7d4e34e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4e34e2"]])

export default __exports__